import { render, staticRenderFns } from "./BizName.vue?vue&type=template&id=5a511a77&lang=pug"
import script from "./BizName.vue?vue&type=script&lang=js"
export * from "./BizName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports